import { component } from 'picoapp';
import { MODAL_OPEN, ACTION_DIALOG_CLOSE, MOUNT_COMPONENTS, THEME_WISHLIST_UPDATED, CART_UPDATING, THEME_CART_UPDATED } from 'events';
import Tracking from 'lib/tracking';
import Wishlist from 'lib/wishlist';

import { clear, stringToNode } from 'utils/node';
import { placeholderItem } from 'utils/product-item';

export default component((node, ctx) => {
  const itemContainer = node.querySelector('[data-items]');

  const checkEmpty = () => {
    if (Wishlist.items.length === 0) {
      node.classList.add('is-empty');
    }
  };

  const fetchProduct = (handle, id = null) => {
    const ITEM_VIEW = 'wishlist-item';
    const url = new URL(location.origin);
    url.pathname = `products/${handle}`;
    url.searchParams.set('view', ITEM_VIEW);

    if (id !== null) {
      url.searchParams.set('variant', id);
    }

    return fetch(url);
  };

  const initEmpty = () => {
    const empty = node.querySelector('[data-empty]');

    empty.addEventListener('click', () => {
      Wishlist.empty();

      ctx.emit(THEME_WISHLIST_UPDATED, { wishlist: Wishlist.items });

      node.classList.add('is-empty');
      clear(itemContainer);
    });
  };

  const initAddAll = () => {
    const addAll = node.querySelector('[data-add-all]');
    const DATA_VIEW = 'data';

    addAll.addEventListener('click', async () => {
      const items = Wishlist.getItems();
      const itemsToAdd = items.filter((item) => item.id);
      const notSelected = items.filter((item) => !item.id);

      if (notSelected.length > 0) {
        const fetches = notSelected.map(async (item) => {
          const url = new URL(location.origin);
          url.pathname = `products/${item.handle}`;
          url.searchParams.set('view', DATA_VIEW);

          const response = await fetch(url);
          const data = await response.json();

          return data;
        });

        const data = await Promise.all(fetches);
        const titles = data.map((item) => item.title);
        alert(theme.strings.wishlist.selectVariantFor.replace('{{ products }}', titles.join(', ')));

        return;
      }

      if (itemsToAdd.length > 0) {
        ctx.emit(CART_UPDATING);

        const formData = {
          items: itemsToAdd.map((item) => ({
            id: item.id,
            quantity: 1,
          })),
        };

        const response = await fetch(`${theme.endpoints.cartAdd}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData),
        });

        if (response.status === 200) {
          document.dispatchEvent(new CustomEvent('cart:update'));
          ctx.emit(MODAL_OPEN, null, { id: 'cart', props: { action: 'add_to_cart' } });
        } else {
          const data = await response.json();
          alert(`${data.message}: ${data.description}`);
        }
      }
    });
  };

  const initItems = () => {
    Wishlist.items.forEach(async (item, index) => {
      const placeholder = stringToNode(`
        <div class="${itemContainer.dataset.items}">${placeholderItem(index)}</div>
      `);
      itemContainer.appendChild(placeholder);

      fetchProduct(item.handle, item.id).then(async (response) => {
        if (response.ok) {
          const view = await response.text();

          itemContainer.replaceChild(
            stringToNode(
              `<div class="${itemContainer.dataset.items}" data-handle="${item.handle}">${view}</div>`,
            ),
            placeholder,
          );

          ctx.emit(MOUNT_COMPONENTS);
        } else if (response.status === 404) {
          Wishlist.remove(item.handle);
          placeholder.parentNode.removeChild(placeholder);
        }
      });
    });

    Tracking.trackViewItemList({
      productHandles: Wishlist.items.map((item) => item.handle),
      placement: 'wishlist',
    });
  };

  const replaceItem = (handle, replacement) => {
    const placeholder = itemContainer.querySelector(`[data-handle="${handle}"]`);

    fetchProduct(replacement).then(async (response) => {
      const view = await response.text();

      itemContainer.replaceChild(
        stringToNode(
          `<div class="${itemContainer.dataset.items}" data-handle="${replacement}">${view}</div>`,
        ),
        placeholder,
      );

      ctx.emit(MOUNT_COMPONENTS);
    });
  };

  checkEmpty();
  initItems();
  initEmpty();
  initAddAll();

  document.addEventListener('theme:product:swap', ({ detail }) => {
    const { handle, product } = detail;

    if (handle === product) {
      return;
    }

    Wishlist.replace(product, handle);
    replaceItem(product, handle);

    ctx.emit(ACTION_DIALOG_CLOSE);
  });

  node.addEventListener('click', (event) => Tracking.selectItemCallback(event, false, true));
});
